// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--_Rsbc","slide":"styles-module--slide--3HsIN"};